import React, { useEffect } from "react"
import { withFormsy } from "formsy-react"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { ListSelect, InactiveOptionsItemRenderer } from "shared/selects"

const FormsyDepartmentSelect = withFormsy(({
  setValue,
  isFormSubmitted,
  isPristine,
  setShowErrors,
  value,
  ...rest
}) => {
  const { nameWithArticle } = useCustomName(DEPARTMENT_KEY)

  useEffect(() => {
    setShowErrors(isFormSubmitted || !isPristine)
  }, [isFormSubmitted, isPristine, setShowErrors])

  return (
    <ListSelect
      isFormSubmitted={isFormSubmitted}
      isPristine={isPristine}
      onChange={(newValue) => setValue(newValue ? { department_id: newValue } : {})}
      value={value?.department_id}
      itemRenderer={InactiveOptionsItemRenderer}
      label={`select ${nameWithArticle}`}
      {...rest}
    />
  )
})

FormsyDepartmentSelect.displayName = "FormsyDepartmentSelect"

export default FormsyDepartmentSelect
